<template>
    <div>

        <config-main-title>
            Resultados Legados do Laboratório
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="form-row mb-3">
                <div class="col col-12 col-md-3">
                    <az-input 
                        icon="fa-solid fa-user-injured fa-fw"
                        placeholder="Id do Paciente..."
                        v-model="filtro.st_id_paciente" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input 
                        icon="fa-solid fa-play fa-fw"
                        placeholder="Id do Atendimento..."
                        v-model="filtro.st_id_atendimento" />
                </div>
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb>
                            <importacao service="lab_legados" @refresh="load()" :chunk_size="10000" />
                            <div class="input-group-append">
                                <az-submit color="outline-primary" @click="load()" :hide_content_while_loading="true">
                                    <i class="fas fa-sync-alt fa-fw"></i>
                                </az-submit>
                            </div>
                        </template>
                    </az-input>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum legado identificado.'" 
                icon="fas fa-search" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="small text-muted">
                {{ dados.from }} - {{ dados.to }}  / {{ dados.total }}
            </div>

            <div class="bg-white">
                <table class="table table-sm hover-bg small mb-0">
                    <thead>
                        <tr>
                            <th>Paciente</th>
                            <th>Atendimento</th>
                            <th>Data</th>
                            <th>Exame</th>
                            <th>Campo</th>
                            <th>Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in lista" :key="idx">
                            <td class="text-nowrap">{{ item.st_id_paciente }} - {{ item.st_nome_paciente }}
                                <template v-if="item.pacientes && item.pacientes.length">
                                    <div v-for="(pac, idx) in item.pacientes" :key="idx" class="small text-muted">
                                        {{ pac.id_pessoa }} - {{ pac.st_nome }}
                                    </div>
                                </template>
                            </td>
                            <td>{{ item.st_id_atendimento }}</td>
                            <td>{{ $util.getFormatDate(item.dt_data_coleta) }}</td>
                            <td>{{ item.st_id_exame }} / {{ item.st_nome_exame }}</td>
                            <td>{{ item.st_id_campo }} 
                                <div v-if="item.st_nome_campo" class="small text-muted">
                                    {{ item.st_nome_campo }}
                                </div>
                            </td>
                            <td>{{ item.st_valor }} <span class="small text-muted">{{ item.st_unidade }}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <br><br><br><br><br><br><br><br><br><br>

        </div>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && ( dados.last_page > 1 || ( !dados.last_page && dados.to >= dados.per_page ) )">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page ? dados.last_page : ( dados.current_page + 1 )"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="load">
                </paginate>
            </div>
        </nav>

    </div>
</template>

<script>
// import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import Importacao from '../shared/Importacao.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            filtro: { 
                periodo: 'm', 
                st_id_paciente: "", 
                st_id_atendimento: "", 
            },
            edicao_datas: null, 
            edicao_data: null,
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        Importacao,
        AzSubmit,
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            if ( this.edicao_datas ) {
                return [ 
                    this.edicao_datas, 
                ];
            }

            return this.dados && this.dados.data && this.dados.data.length ? 
                this.dados.data.filter (item => { 
                    return ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },
    },

    methods: { 
        load (page = 1) { 
            this.$util.load(this, { 
                service:'lab_legados',
                func: 'index',
                parms: { 
                    cadastro: true,
                    size: 1000, 
                    page: page,
                    ...this.filtro, 
                },
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Resultados Legados do Laboratório", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>